<div id="dialog-container">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <mat-divider></mat-divider>

  @if (missingRequiredFields.length > 0) {
    <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
      <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
      <ul>
        @for (field of missingRequiredFields; track field.code) {
          <li>{{ field.label }}</li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions class="center">
      <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  } @else {
    <file-uploader [uploadData]="data.uploadData"
                   (uploadInProgress)="uploadIsInProgress($event)"
                   (fileUploaded)="createNewDocuments($event)"
                   class="uploader-container">
    </file-uploader>
    @if (!preventUploadFiles) {
      <mat-dialog-actions>
        <button (click)="removeAllFiles()" mat-stroked-button matDialogClose="cancel">
          {{ data['cancelButtonText'] }}
        </button>
        <button [disabled]="isUploadInvalid()"
                color="accent"
                mat-raised-button
                matDialogClose="yes">
          {{ data['doneButtonText'] }}
        </button>
      </mat-dialog-actions>
    }
  }
</div>
